import { RoundDetailsCard } from '../../02-molecules'
import { ComponentProps } from './types'

export const RoundDetailsPanel = ({ round, series }: ComponentProps) => {
  return <RoundDetailsCard round={round} series={series} />
}
